import React, { useState } from "react";
import { apiFetch } from "../../services/api";
import LoadingButton from "../../components/common/LoadingButton";
import V2AuthLayout from "../components/V2AuthLayout";
import { useV2Theme } from "../theme/ThemeProvider";

const inputClass =
  "mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 shadow-sm focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500/25";

export default function V2ForgotPasswordPage({ onBackToLogin }) {
  const { tokens } = useV2Theme();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await apiFetch("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.error) {
          setError(data.error);
          setMessage("");
        } else {
          setMessage(data.message || "If an account exists for this email, you will receive reset instructions.");
        }
      } else {
        let errMsg = "Failed to send password reset email";
        try {
          const errorData = await response.json();
          if (errorData?.detail) {
            if (typeof errorData.detail === "string") {
              errMsg = errorData.detail;
            } else if (errorData.detail?.message) {
              errMsg = errorData.detail.message;
            } else {
              errMsg = String(errorData.detail);
            }
          }
        } catch {
          /* ignore */
        }
        setError(errMsg);
      }
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const linkBtn = "text-sm font-medium text-blue-700 hover:text-blue-600";

  return (
    <V2AuthLayout
      title="Reset password"
      subtitle="Enter your email and we’ll send a link to set a new password."
    >
      <form className="space-y-5" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-slate-700">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            className={inputClass}
            placeholder="you@organization.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {error ? (
          <div className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800">
            {error}
          </div>
        ) : null}

        {message ? (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
            {message}
          </div>
        ) : null}

        <LoadingButton
          type="submit"
          loading={isLoading}
          loadingLabel="Sending…"
          className={`w-full ${tokens.button.primary} disabled:opacity-50`}
        >
          Send reset link
        </LoadingButton>

        <button type="button" onClick={onBackToLogin} className={`w-full text-center ${linkBtn}`}>
          ← Back to sign in
        </button>
      </form>
    </V2AuthLayout>
  );
}
